import { type PopupHeaderProps } from "components/popup/header";
import { Component } from "./styles";

export function PopupHeader(props: PopupHeaderProps) {
  return <Component {...props} />;
}
